module.exports = __webpack_public_path__ + "static/media/javascript-programming-language.4b48442d.svg";